import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AuthService} from '../../../services/auth.service';
import {ActivatedRoute, NavigationStart, Router} from '@angular/router';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation,
    fadeInUpBigOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {UserService} from '../../../services/user.service';
import {Subscription} from 'rxjs';
import {EventsService} from '../../../services/events.service';
import {environment} from '../../../../environments/environment';
import {AnalyticsService} from '../../../services/analytics.service';
import {ReviewService} from '../services/review.service';
import {ReviewReportFormModel, ReviewReportSimpleModel, UserReviewReportListResponse} from '../models/review.model';
import {DelegateSimpleModel} from '../../team/models/delegate.model';
import {IonModal} from '@ionic/angular';

@Component({
    selector: 'app-review-report-list-page',
    templateUrl: 'review-report-list.page.html',
    styleUrls: ['review-report-list.page.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
        fadeInUpBigOnEnterAnimation({anchor: 'enterUp', duration: 300}),
    ],
})
export class ReviewReportListPage implements OnInit, OnDestroy {

    @ViewChild('addRespondentModalRef', {static: false}) addRespondentModalRef: IonModal;

    subscriptions: Subscription[] = [];

    environment = null;
    menuVisible = true;

    delegateId: number = null;
    delegate: DelegateSimpleModel = null;

    reports: ReviewReportSimpleModel[] = null;
    reportsPromise: Promise<UserReviewReportListResponse> = null;
    reportsValid = false;

    userType = null;

    platform = 'website';

    isModalOpen: boolean = false;
    currentReport: ReviewReportSimpleModel = null;
    keyword: string = null;
    usersList: DelegateSimpleModel[] = [];
    currentUser: DelegateSimpleModel = null;
    isUsersListLoading = false;
    isRespondentAdded = false;
    isRespondentAdding = false;

    constructor(
        private event: EventsService,
        private activatedRoute: ActivatedRoute,
        public authService: AuthService,
        public userService: UserService,
        private analytics: AnalyticsService,
        private reviewService: ReviewService,
        private router: Router,
    ) {
        this.environment = environment;
        this.subscriptions.push(
            this.event.subscribe('login', () => this.reportsValid = false)
        );
        this.subscriptions.push(
            this.event.subscribe('review.saveMyReviewReport', () => this.reportsValid = false)
        );
        this.subscriptions.push(
            this.event.subscribe('review.deleteMyReviewReport', () => this.reportsValid = false)
        );
        this.subscriptions.push(
            this.event.subscribe('logout', () => this.reportsValid = false)
        )
    }

    ngOnInit(): void {
        this.platform = environment.platform;
        this.delegateId = Number(this.activatedRoute.snapshot.paramMap.get('delegate_id'));
    }

    ionViewWillEnter() {
        this.userType = this.authService.getUserType();

        if (this.reports === null || !this.reportsValid) {
            this.reportsPromise = this.reviewService.getUserReviewReportList(this.delegateId);
        }
    }

    ionViewDidEnter() {
        this.analytics.trackView('Professional Development Review');

        if (this.reports === null || !this.reportsValid) {
            this.reportsPromise.then(data => {
                this.delegate = data.delegate;
                this.reports = data.reports;
                this.reportsValid = true;
            });
        }
    }

    ionViewWillLeave() {
        this.addRespondentModalRef.dismiss();
    }

    searchUsers() {
        if (this.keyword.length > 0) {
            this.currentUser = null;
            this.usersList = [];
            this.isUsersListLoading = true;
            this.userService.getUsersList(this.keyword, 3).then(data => {
                this.isUsersListLoading = false;
                this.usersList = data;
            });
        } else {
            this.usersList = [];
        }
    }

    pickUser(user: DelegateSimpleModel) {
        this.currentUser = user;
    }

    addRespondent() {
        this.isRespondentAdded = false;
        this.isRespondentAdding = true;
        this.reviewService.addReviewReportFeedbackRespondent(this.currentReport.id, this.currentUser.id).then(data => {
            this.isRespondentAdded = true;
            this.isRespondentAdding = false;
            setTimeout(() => {
                this.isRespondentAdded = false;
            }, 3000);
        }).catch(e => {
            this.isRespondentAdded = true;
            this.isRespondentAdding = false;
            setTimeout(() => {
                this.isRespondentAdded = false;
            }, 3000);
        });
    }

    openModal(event, report: ReviewReportSimpleModel) {
        event.stopPropagation();
        if (report.status) {
            return false;
        }

        this.currentReport = report;
        this.keyword = '';
        this.usersList = [];
        this.isModalOpen = true;
    }

    onModalWillDismiss(event) {
        this.isModalOpen = false;
    }

    modalConfirm() {
        this.isModalOpen = false;
    }
    modalCancel() {
        this.isModalOpen = false;
    }

    goBack() {
        this.router.navigate(['/team']);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(i => i.unsubscribe());
    }
}
